<template>
    <modal name="modal-result-photo" id="result-photo-modal" @before-open="urlForPhoto" :width="800" :pivotY="0.2" height="auto">
        <img class="result-photo" :src="photo"/>
    </modal>
</template>

<script>
    export default {
        name: "ModalShowPhotoInResult",
        methods:{
            urlForPhoto(event) {
                this.photo = event.params;
            }
        },
        data() {
            return {
                photo: null
            }
        }
    }
</script>

<style scoped>
    .result-photo {
        width: 100%;
        height: auto;
        display: block;
    }

    #result-photo-modal {
        user-select: none;
    }
</style>
